import React from 'react';
import {
  Chip,
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chip: {
      fontSize: '11px',
      height: '20px',
      backgroundColor: '#CCE5DD',
      color: '#003F2D',
      border: 'none',
      fontWeight: 600,
      padding: '0 8px',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#B8D9CF',
      },
    },
  }),
);

export interface BadgeProps {
  count: number;
  label?: string;
  onClick?: () => void;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({ 
  count, 
  label = 'similar prompts',
  onClick,
  className = '' 
}) => {
  const classes = useStyles();
  
  return (
    <Chip
      label={`${count} ${label}`}
      size="small"
      onClick={onClick}
      className={`${classes.chip} ${className}`}
    />
  );
};
